module.exports = __webpack_public_path__ + "static/media/ta-rpo-01.9de60736.png";